import { useTheme } from '@emotion/react';
import { Box, Typography, useMediaQuery } from '@mui/material';

import WhatBox from './WhatBox';

import Individualentwicklung from '../../assets/Individualentwicklung.svg';
import Integration from '../../assets/Integration.svg';
import Webhosting from '../../assets/Webhosting.svg';

const slides = [
  {
    id: 1,
    title: 'Individualentwicklung',
    description:
      'Gemeinsam mit Ihnen planen und implementieren wir Web-Apps für unterschiedlichste Anwendungsfälle.',
    img: Individualentwicklung,
  },
  {
    id: 2,
    title: 'Webhosting',
    description:
      'Ob kleine Landingpage oder Online-Shop mit hunderttausenden Aufrufen am Tag - wir sind Spezialisten im verwalten von Cloud-Infrastruktur.',
    img: Webhosting,
  },
  {
    id: 3,
    title: 'Integration von Systemen',
    description:
      'Sie setzen verschiedene Softwarelösungen ein, die nicht miteinander reden? Wir bieten Lösungen zur Integration von Systemen an!',
    img: Integration,
  },
];

export default function What() {
  const theme = useTheme();
  const isTabletView = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '70%',
        maxWidth: '1200px',
        pt: '60px',
        pb: '200px',
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
      }}
    >
      <Box
        sx={{
          mb: '60px',
          [theme.breakpoints.down('md')]: {
            width: '80%',
            alignSelf: 'center',
          },
        }}
      >
        <Typography
          sx={{
            display: 'inline',
            fontSize: '48px',
            fontWeight: '800',
            fontFamily: 'Karla, sans-serif',
            color: 'primary.main',
          }}
        >
          Was{' '}
        </Typography>

        <Typography
          sx={{
            display: 'inline',
            fontSize: '48px',
            fontWeight: '800',
            fontFamily: 'Karla, sans-serif',
          }}
        >
          tun wir?
        </Typography>
      </Box>

      {isTabletView ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '80%',
              display: 'flex',
              overflowX: 'auto',
              scrollSnapType: 'x mandatory',
              gap: '10px',
            }}
          >
            {slides.map((slide, index) => (
              <Box
                key={slide.id}
                sx={{
                  ml: index === 0 ? '10%' : '0',
                  mr: index === slides.length - 1 ? '10%' : '0',
                  width: '100%',
                  flexShrink: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  scrollSnapAlign: 'center',
                }}
              >
                <img
                  src={slide.img}
                  alt={slide.title}
                  style={{ width: '100%', height: '100%' }}
                />

                <Box sx={{ minHeight: '20vh' }}>
                  <Typography
                    sx={{
                      mt: '15px',
                      color: '#1E1E1E',
                      fontSize: '16px',
                      fontWeight: '700',
                    }}
                  >
                    {slide.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: '#1E1E1E',
                      fontSize: '16px',
                      fontWeight: '400',
                    }}
                  >
                    {slide.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '20px',
          }}
        >
          {slides.map((slide) => (
            <Box key={slide.id}>
              <WhatBox
                title={slide.title}
                description={slide.description}
                image={slide.img}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
